module.exports = __webpack_public_path__ + "img/mysql.574507f1.png";